import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
// @mui
import { Stack, Typography, Grid, Button } from '@mui/material';
import Link from '@mui/material/Link';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import moment from 'moment'
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

dayjs.extend(utc);
dayjs.extend(timezone);

// ----------------------------------------------------------------------

export default function HomePage(props) {

   const theme = useTheme();
      const matches = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <>
      <Helmet>
        <title> Home | OneT | Leading DevSecOps Service Provider</title>
      </Helmet>

      <Grid style={{top: 0, width: '100%',
        display: "flex",justifyContent: "center", alignItems: "center",  flexDirection: "column"  }}>

{matches ? <Grid style={{ zIndex:-1, position: "fixed", top: 0,backgroundColor: '#1b0049', 
        width: "100%",
        display: "flex", justifyContent: "flex-end", flexDirection: "column"  }}>
            <video height={"100%"} className='videoTag' playsInline autoPlay loop muted>
                <source src={"/assets/videobg.mp4"} type='video/mp4' />
            </video>
          </Grid> : <Grid style={{ zIndex:-1, position: "fixed", top: 0,backgroundColor: '#1b0049', 
        
        height: "110vh",
        display: "flex", justifyContent: "flex-end", flexDirection: "column"  }}>
            <video height={"100%"} className='videoTag' playsInline autoPlay loop muted>
                <source src={"/assets/videobg.mp4"} type='video/mp4' />
            </video>
          </Grid>}

        <Grid style={{ zIndex:1, position: "absolute", top: 0, width: '100%', backgroundColor: '#000000', 
          height: "100%",
          opacity: .7,
          display: "flex",justifyContent: "center", alignItems: "center",  flexDirection: "column"  }}/>


        <Grid style={{ height: '83vh', maxWidth: 1200, zIndex:2, marginTop: 120, width: "100%", display: "flex", padding: 25,  paddingTop: 60, paddingBottom: 80,
            flexDirection: "column",  backgroundColor: "Transparent" }}>
            
            <Typography style={{marginTop: -10, fontSize: 20, color: 'white' }}>
            {props.data? props.data.subtitle : ""}
            </Typography>
            <Typography style={{ fontWeight: "bold", fontSize: 40, color: 'white', textTransform: "uppercase" }}>
            {props.data? props.data.title : ""}
            </Typography>
           
            <Typography style={{maxWidth: 500,fontWeight: 300, fontSize: 16, color: 'white', opacity: .8 }}>
            {props.data? props.data.description : ""}
            </Typography>
            
        </Grid>
        
      </Grid>
    </>
  );
}
